'use client';
import { useSuspenseQuery } from '@tanstack/react-query';
import { BLOG_QUERIES } from '@/infrastructure/blog/utils/queries';
import type { BlogPostSummaryRequest } from '@/infrastructure/blog/utils/types';

export const useBlogService = () => {
  const useGetBlogPostsSummary = (params?: BlogPostSummaryRequest) => {
    return useSuspenseQuery(BLOG_QUERIES.getBlogPostsSummary(params));
  };

  return {
    useGetBlogPostsSummary,
  };
};
